import { MousePointer2 } from "lucide-react";

const ICON = {
  chrome: <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="13" rx="2" /><path d="M12 8v6m-3-3 3 3 3-3M8 21h8" /></svg>,
  edge: <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><path d="M17.5 14v7M14 17.5h7" /></svg>,
};

// Looping mock browser: cursor finds the install control, clicks Install, an app icon lands in the taskbar.
export default function InstallAnimation({ browser }) {
  const safari = browser === "safari";
  return (
    <div className="pci-stage relative h-56 overflow-hidden rounded-xl border border-slate-200 bg-gradient-to-b from-sky-100 to-indigo-100" data-testid="pc-install-animation" aria-hidden="true">
      {safari && (
        <div className="absolute inset-x-0 top-0 flex h-5 items-center gap-3 bg-white/80 px-3 text-[10px] font-medium text-slate-700">
          <span className="font-bold"></span><span>Safari</span><span className="pci-menu rounded px-1">File</span><span>Edit</span><span>View</span>
        </div>
      )}
      <div className={`pci-window absolute left-6 right-6 ${safari ? "top-8" : "top-4"} bottom-12 overflow-hidden rounded-lg bg-white shadow-lg`}>
        <div className="pci-chrome flex h-8 items-center gap-2 border-b border-slate-200 bg-slate-100 px-2">
          <span className="flex gap-1"><i className="h-2 w-2 rounded-full bg-rose-400" /><i className="h-2 w-2 rounded-full bg-amber-400" /><i className="h-2 w-2 rounded-full bg-emerald-400" /></span>
          <div className="flex h-5 flex-1 items-center justify-between rounded-full bg-white px-2 text-[10px] text-slate-500">
            <span>snaplist.app/listing-queue</span>
            {!safari && <span className="pci-target relative text-slate-700">{ICON[browser] || ICON.chrome}</span>}
          </div>
        </div>
        <div className="space-y-1.5 p-3">
          <div className="h-2.5 w-1/3 rounded bg-[#0053DA]/80" />
          <div className="h-2 w-2/3 rounded bg-slate-200" />
          <div className="grid grid-cols-3 gap-1.5 pt-1">{[0, 1, 2].map((i) => <div key={i} className="h-10 rounded bg-slate-100" />)}</div>
        </div>
      </div>
      {safari && (
        <div className="pci-dropdown absolute left-[5.2rem] top-5 w-28 rounded-md border border-slate-200 bg-white py-1 text-[10px] text-slate-700 shadow-lg">
          <p className="px-2 py-0.5 text-slate-400">New Window</p>
          <p className="pci-pick mx-1 rounded px-1 py-0.5">Add to Dock…</p>
        </div>
      )}
      <div className={`pci-popup absolute w-44 rounded-lg border border-slate-200 bg-white p-2 shadow-xl ${safari ? "left-1/2 top-16 -translate-x-1/2" : "right-8 top-12"}`}>
        <p className="text-[11px] font-bold text-slate-900">{safari ? "Add to Dock" : "Install app?"}</p>
        <p className="flex items-center gap-1.5 py-1 text-[10px] text-slate-600"><span className="flex h-4 w-4 items-center justify-center rounded bg-[#0053DA] text-[7px] font-bold text-white">SL</span> SnapList</p>
        <div className="flex justify-end"><span className="pci-btn rounded-full bg-[#0053DA] px-2 py-0.5 text-[10px] font-semibold text-white">{safari ? "Add" : "Install"}</span></div>
      </div>
      <div className="absolute inset-x-0 bottom-0 flex h-9 items-center justify-center gap-2 bg-slate-900/80">
        {[0, 1, 2].map((i) => <span key={i} className="h-5 w-5 rounded bg-white/25" />)}
        <span className="pci-dock flex h-6 w-6 items-center justify-center rounded-md bg-[#0053DA] text-[8px] font-bold text-white ring-2 ring-white">SL</span>
      </div>
      <MousePointer2 className={`pci-cursor ${safari ? "pci-cursor-safari" : ""} absolute h-5 w-5 fill-white text-slate-900 drop-shadow`} />
    </div>
  );
}
